import React from 'react';
import SupportChatWorkspace from '../../components/admin/SupportChatWorkspace';

export default function DealerSupportChat() {
  return (
    <div className="p-6">
      <h1 className="sr-only">Dealer Support Chat</h1>
      <SupportChatWorkspace user_type="dealer" title="Dealer Support Chat Workspace" />
    </div>
  );
}
